import { Component, OnInit } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-my-document',
  templateUrl: './my-document.component.html',
  styleUrls: ['./my-document.component.scss'],
})
export class MyDocumentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
